module.exports = __webpack_public_path__ + "img/timer_off.fdb7c3e6.svg";